import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )}
    />
  );
};

export default withRouter(ProtectedRoute);
